import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { GetMunicipality, saveMunicipality } from './index';

// Api's
import { municipalityApi } from '../../api';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* getMunicipalitySaga(action: GetMunicipality) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      municipalityApi.getDomain,
      action.payload.request
    );

    if (response.data.result) {
      yield put(saveMunicipality(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveMunicipality(null, true, resultError.messagesDataError));
    }
  }
}
